import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.push.js";
import request from '@/utils/request';
import { officialList } from '@/api';
import { mapMutations } from 'vuex';
export default {
  data: function data() {
    return {
      list1: [],
      list2: [],
      loaded: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(['UPDATE_SEARCH_VALUE'])), {}, {
    queryOfficialList: function queryOfficialList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loaded = true;
              params = {
                pageNum: 1,
                pageSize: 15,
                catCodes: 'drug_instruction'
              };
              _context.next = 4;
              return request.get(officialList, {
                params: params
              });
            case 4:
              res = _context.sent;
              _this.loaded = false;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              _this.list = res.obj.rows || [];
              _this.list1 = _this.list.slice(0, 3).map(function (item, index) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  cover: require("@/assets/images/index/medication-guidance-".concat(index + 1, ".png"))
                });
              });
              if (_this.list.length > 3) {
                _this.list2 = _this.list.slice(3, 14);
              } else {
                _this.list2 = [];
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick(title) {
      this.UPDATE_SEARCH_VALUE(title);
      this.$router.push('/medicationGuidance');
    }
  }),
  mounted: function mounted() {
    this.queryOfficialList();
  }
};